/** /managerDashboard/vehicles
 * @see https://github.com/search?q=repo%3ASignolteam/managers_service%20VehicleNamesResponseDto
 */
export const getVehiclesRespMaritime = () => {
  return {
    vehicleTypes: [
      "Stolt Achievement",
      "Stolt Breland",
      "Stolt Concept",
      "Stolt Creativity",
      "Stolt Effort",
      "Stolt Norland",
      "Stolt Tenacity",
    ],
    vehicleIds: [
      "9102095",
      "9124469",
      "9178197",
      "9178202",
      "9414060",
      "9414084",
      "9680102",
    ],
    vehicleCount: 7,
  };
};
